import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, UtilityService } from 'app/core/core.module';
import { Part } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import _ from 'lodash';

@Component({
    selector: 'app-inventory-projection-overview',
    templateUrl: './inventory-projection-overview.component.html',
    styleUrls: ['./inventory-projection-overview.component.scss'],
    standalone: false,
})
export class InventoryProjectionOverviewComponent implements OnInit {
    statuses: any[];
    projections: any;

    showAllOrders = false;
    filter: any;
    showCompleted = false;
    canUpdateStatus = false;
    canCancelOrder = false;

    parts: any = [];

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    @ViewChild('partsGrid') partsGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(private uow: GenesisUnitOfWork, private router: Router, private auth: AuthService, private appInfo: AppInformationService, private utility: UtilityService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.projections = await this.uow.getInventoryProjections();
        await this.getParts();
        await this.getInventoryData();
    }

    async getParts() {
        const parts = (await this.uow.getPartsForSearch()) as Part[];
        this.parts = parts;
        await this.setAliasHTML();
    }

    async setAliasHTML() {
        const aliases = (await this.uow.getActivePartAliases({ select: 'partId, partNumber, vendor.companyName', orderBy: 'vendor.companyName, partNumber' })) as any[];
        this.parts.forEach((part) => {
            const partAliases = aliases.filter((alias) => alias.partId === part.id);
            part.aliasHTML = partAliases.map((alias) => `${alias.vendor_CompanyName} -- ${alias.partNumber ?? ''}`).join('<br/>');
        });
    }

    async refresh() {
        // this.partsGrid.instance.clearSelection();
        // this.partsGrid.instance.clearFilter();
        this.parts.forEach((part) => {
            part._projectedQty = 0;
            part._onOrder = 0;
            part._onBackOrder = 0;
            part.allocated = 0;
            part.projectedInventory = 0;
            part._onOrder = 0;
            part._onBackOrder = 0;
        });
        this.appInfo.pleaseWaitShow();
        await this.getInventoryData();
        this.appInfo.pleaseWaitHide();
    }

    async getInventoryData() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        const projectionInfos = await this.uow.getInventoryProjectionsInfosForParts(selectedRows.map((p) => p.id));
        this.parts.forEach((part) => {
            const info = _.find(projectionInfos, { partId: part.id }) as any;
            part._projectedQty = !!info ? info.quantity : 0;
            part.projectedInventory = part.inStock - part.allocated - part._projectedQty;
        });

        await this.getPurchaseOrderInfosForParts();
        await this.getOrderLineDetailParts();
        this.partsGrid.instance.refresh();
        // await this.getParentOnOrderQuantities();
    }

    async getPurchaseOrderInfosForParts() {
        const purchaseOrderInfos = await this.uow.getPurchaseOrderInfosForParts();
        this.parts.forEach((part) => {
            const info = _.find(purchaseOrderInfos, { partId: part.id }) as any;
            part._onOrder = !!info ? info.onOrder : 0;
            part._onBackOrder = !!info ? info.onBackOrder : 0;
        });
    }

    async getOrderLineDetailParts() {
        const orderLinePartsNew = await this.uow.getOrderLineDetailPartsOnNew();
        this.parts.forEach((part) => {
            const orderLinePartInfo = _.find(orderLinePartsNew, { partId: part.id }) as any;
            part.allocated = !!orderLinePartInfo ? orderLinePartInfo.partCountOnNewStatus : 0;
            part.projectedInventory = part.inStock - part.allocated - part._projectedQty;

            part.stockLevel = part.projectedInventory < 0 ? 'none' : part.projectedInventory < part.reOrderMinimum ? 'low' : 'sufficient';
        });
    }

    // async getParentOnOrderQuantities() {
    //     const partQuantities = await this.uow.getParentOnOrderQuantities();
    //     this.parts.forEach((part) => {
    //         const parentLine = _.find(partQuantities, { id: part.id }) as any;
    //         part.onOrderParent = !!parentLine ? parentLine.totalOnOrder : 0;
    //     });
    // }

    // async toggleCompleted() {
    //     this.showCompleted = !this.showCompleted;
    //     this.sessionInfo.setItem('build-assembly-show-completed', this.showCompleted, false);
    //     await this.getData();
    // }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

    selectionChange(e) {}

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async onRowPrepared(e) {
        if (e.rowType === 'data') {
            if (e.data.projectedInventory < 0) {
                e.rowElement.className = e.rowElement.className + ' projection no-inventory';
            }
            if (e.data.projectedInventory > 0) {
                if (e.data.projectedInventory < e.data.reOrderMinimum) {
                    e.rowElement.className = e.rowElement.className + ' projection low-inventory';
                }
                if (e.data.projectedInventory >= e.data.reOrderMinimum) {
                    e.rowElement.className = e.rowElement.className + ' projection sufficient-inventory';
                }
            }
        }
    }

    async open(projection: any) {
        this.router.navigate(['/projections/' + (!!projection?.id ? projection.id : 'new')]);
    }

    // openPurchaseOrder(buildAssembly: BuildAssembly) {
    //     if (!buildAssembly) return;
    //     this.router.navigate(['/purchase-orders/' + buildAssembly.purchaseOrderId]);
    // }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        await this.open(e.data);
    }

    partDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        this.router.navigate(['/parts/' + e.data.id]);
    }

    async delete() {
        const selectedRow = this.dataGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow) return;
        const success = await confirm('Are you sure you want to DELETE this?', this.appInfo.settings.company);
        if (!success) return;

        this.appInfo.pleaseWaitShow();
        await this.utility.deleteInventoryProjection(selectedRow.id);

        selectedRow.deleted = new Date();
        selectedRow.deletedBy = this.auth.currentUser.userName;
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
}
